import React, { lazy, Suspense, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <h4>Something went wrong loading this page.</h4>
          <p style={{ color: "#666", fontSize: "14px" }}>{this.state.error?.message}</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: "12px", padding: "8px 20px", cursor: "pointer" }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
//import through lazy loading
const Marque = lazy(() => import("../components/Marque/Index"));

// const Header = lazy(() => import("../components/Header/index"));
const Navbar = lazy(() => import("../components/Navbar/Navbar"));
// const Footer = lazy(() => import("../components/Footer/Footer"));
// const BottomFooter = lazy(() =>
//   import("../components/BottomFooter/BottomFooter")
// );
const FooterNew = lazy(() => import("../components/FooterNew/Index.jsx"));
// const componentMap = {
//   Home: lazy(() => import("../pages/Home/Home")),
//   ServiceProvider: lazy(() => import("../pages/ServiceProvider/ServiceProvider.jsx")),
//   // AboutUs: lazy(() => import("../pages/AboutUs/index")),
//   AboutUs: lazy(() => import("../pages/AboutUsSectionNew/Index.jsx")),
//   Loginwithemail_V2: lazy(() =>
//     import("../pages/LoginWithEmailV2/LoginWithEmailV2")

// const Header = lazy(() => import("../components/Header/index"));
// const Footer = lazy(() => import("../components/Footer/Footer"));
// const BottomFooter = lazy(
//   () => import("../components/BottomFooter/BottomFooter"),
// );
const componentMap = {
  Home: lazy(() => import("../pages/Home/Home")),
  ServiceProvider: lazy(
    () => import("../pages/ServiceProvider/ServiceProvider.jsx"),

  ),
  AboutUs: lazy(() => import("../pages/AboutUsSectionNew/Index.jsx")),
  Loginwithemail_V2: lazy(
    () => import("../pages/LoginWithEmailV2/LoginWithEmailV2"),
  ),
  OrganisationalStructure: lazy(
    () => import("../pages/OrganisationalStructure/index"),
  ),
  MissionVision: lazy(() => import("../pages/MissionVision/MissionVision")),
  Infrastructure: lazy(() => import("../pages/Infrastructure/Infrastructure")),
  Etender: lazy(() => import("../pages/E-Tender/Etender")),

  WebsiteNotification: lazy(
    () => import("../pages/WebsiteNotification/WebsiteNotification"),
  ),
  Calender: lazy(() => import("../pages/Calender/index")),
  DigitalYouthFestival: lazy(
    () => import("../pages/DigitalYouthFestival/DigitalYouthFestival.jsx"),
  ),
  Athletes: lazy(() => import("../pages/Athletes/Athletes")),
  LatestNews: lazy(() => import("../pages/LatestNews/LatestNews")),
  LatestNewsSinglePage: lazy(
    () => import("../pages/LatestNews/LatestNewsSinglePage.js"),
  ),
  LatestVideos: lazy(() => import("../pages/LatestVideos/LatestVideos")),
  NewsDetails: lazy(() => import("../pages/NewsDetails/NewsDetails")),
  Contactus: lazy(() => import("../pages/ContactUs/ContactUs")),
  PhotoGallery: lazy(() => import("../pages/PhotoGallery/PhotoGallery")),
  AthletesProfile: lazy(
    () => import("../pages/AthletesProfile/AthletesProfile"),
  ),
  RightToInfo: lazy(() => import("../pages/RightToInfo/RightToInfo")),
  Scholarship: lazy(() => import("../pages/Scholarship/Scholarship")),
  HeadtoHead: lazy(() => import("../pages/HeadtoHead/HeadtoHead")),
  ForgetPassword: lazy(() => import("../pages/ForgetPassword/ForgetPassword")),
  LoginwithOTP_V2: lazy(() => import("../pages/LoginWithOTPV2/LoginWithOTPV2")),
  OtpVerification: lazy(() => import("../pages/OTPVerification/Index.jsx")),
  OtpwithMobile: lazy(() => import("../pages/LoginwithOTP/index.jsx")),
  // Registration: lazy(() => import("../pages/Registration")),
  Registration: lazy(
    () => import("../pages/Registration/NewRegistrationForm/Index.jsx"),
  ),
  Scheme: lazy(() => import("../pages/Scheme")),
  Schemes: lazy(() => import("../pages/Schemes/Index.jsx")),
  SchemeDetails: lazy(() => import("../pages/SchemeDetails/Index.jsx")),
  SlotBooking: lazy(() => import("../pages/SlotBooking/Index.jsx")),
  VenueDetails: lazy(() => import("../pages/SlotBooking/VenueDetails.jsx")),
  VenueInfraStructure: lazy(
    () => import("../pages/SlotBooking/VenueInfra/VenueInfra.jsx"),
  ),
  VenueInfraStructureDetails: lazy(
    () => import("../pages/SlotBooking/VenueInfra/VenueInfraDetails.jsx"),
  ),
  TicketDetails: lazy(() => import("../pages/SlotBooking/TicketDetails.jsx")),
  Payment: lazy(() => import("../pages/SlotBooking/Payment.jsx")),
  TicketBookingPayment: lazy(
    () => import("../pages/TicketBooking/TicketBookingPayment.jsx"),
  ),
  MyBooking: lazy(() => import("../pages/SlotBooking/Booking/MyBooking.jsx")),
  VenueBookingDetails: lazy(
    () => import("../pages/SlotBooking/VenueBookingDetails.jsx"),
  ),

  TicketBooking: lazy(() => import("../pages/TicketBooking/Index.jsx")),
  TicketBookingList: lazy(
    () => import("../pages/TicketBooking/TicketComp/TicketBookingList.jsx"),
  ),
  TicketBookingDetails: lazy(
    () => import("../pages/TicketBooking/TicketBookingDetails.jsx"),
  ),
  MyTickets: lazy(
    () => import("../pages/TicketBooking/TicketComp/MyTickets.jsx"),
  ),
  MyTicketsDetails: lazy(
    () => import("../pages/TicketBooking/TicketComp/MyTicketDetails.jsx"),
  ),

  ServiceBookingStatus: lazy(
    () => import("../pages/ServiceBookingStatus/ServiceBookingStatus.jsx"),
  ),

  ComingSoon: lazy(() => import("../components/ComingSoonPage/ComingSoon")),
  GovernmentOrder: lazy(() => import("../pages/GovernmentOrder/GovernmentOrder")),
  achiever: lazy(() => import("../pages/AchiverCard/AchiverCard.jsx")),
  UddyamaanUnnayan: lazy(() => import("../pages/UddyamaanUnnayan/UddyamaanUnnayan.jsx")),
  UddyamaanDetail: lazy(() => import("../pages/UddyamaanUnnayan/UddyamaanDetail.jsx")),
  UddyamaanApplyForm: lazy(() => import("../pages/UddyamaanUnnayan/UddyamaanApplyForm.jsx")),
  UddyamaanApplicationView: lazy(() => import("../pages/UddyamaanUnnayan/UddyamaanApplicationView.jsx")),
  UddyamaanMyAssessment: lazy(() => import("../pages/UddyamaanUnnayan/UddyamaanMyAssessment.jsx")),
  InsitutionInitialCard: lazy(
    () => import("../pages/InsitutionInitialCard/InsitutionInitialCard"),
  ),
  InstitutionRegistration: lazy(
    () => import("../pages/InstitutionRegistration"),
  ),
  InstitutionStatusCard: lazy(
    () => import("../pages/InsitutionRegisterStatus/RegistrationStatusCard"),
  ),
  Error404: lazy(() => import("../pages/Error404/Error404.jsx")),
  TermCondition: lazy(
    () => import("../pages/PolicyPages/TermCondition/TermCondition.jsx"),
  ),
  PrivacyPolicy: lazy(() => import("../pages/PolicyPages/PrivacyPolicy.jsx")),
  PrivacyPolicyApp: lazy(
    () => import("../pages/PolicyPages/AppPrivacyPolicy.jsx"),
  ),
  CancelPolicy: lazy(() => import("../pages/PolicyPages/CancellationPolicy")),
  CmTrophyLanding: lazy(() => import("../pages/CmTrophy/CmTrophyLanding.jsx")),
  CmTrophyApplyForm: lazy(() => import("../pages/CmTrophy/CmTrophyApplyForm.jsx")),
  CmTrophySearchApplication: lazy(() => import("../pages/CmTrophy/CmTrophySearchApplication.jsx")),
};

//Route
const authRoutes = [{ path: "", element: "" }];

const publicRoutes = [
  { path: "/", element: "Home" },
  { path: "/aboutUs", element: "AboutUs" },
  { path: "/login_email", element: "Loginwithemail_V2" },
  { path: "/organisational_structure", element: "OrganisationalStructure" },
  { path: "/tender", element: "Etender", props: { id: "1" } },
  { path: "/login_otp", element: "LoginwithOTP_V2" },
  { path: "/forget_password", element: "ForgetPassword" },
  { path: "/otp-verification", element: "OtpVerification" },
  { path: "/login/mobile", element: "OtpwithMobile" },
  { path: "/create-new-password", element: "CreateNewPassword" },
  { path: "/registration", element: "Registration" },
  { path: "/institution-registration", element: "InstitutionRegistration" },
  {
    path: "/institution-registration-profile",
    element: "InsitutionInitialCard",
  },
  { path: "/final-status", element: "InstitutionStatusCard" },
  { path: "/infrastructure", element: "Infrastructure" },
  { path: "/scholarship", element: "Scholarship" },
  { path: "/policie", element: "Etender", props: { id: "7" } },
  { path: "/govt-circular", element: "Etender", props: { id: "8" } },
  { path: "/contact-us", element: "Contactus" },
  { path: "/calendar", element: "Calender" },
  { path: "/tournament", element: "Calender" },
  { path: "/digital-youth-festival", element: "DigitalYouthFestival" },
  { path: "/service-provider", element: "ServiceProvider" },
  { path: "/service-providers-bookings", element: "ServiceBookingStatus" },
  { path: "/athletes", element: "Athletes" },
  { path: "/athletes_profile", element: "AthletesProfile" },
  { path: "/head_to_head", element: "HeadtoHead" },
  { path: "/latest-news", element: "LatestNews" },
  { path: "/latest-news/:id", element: "LatestNewsSinglePage" },
  { path: "/news-details", element: "NewsDetails" },
  { path: "/latest-videos", element: "LatestVideos" },
  { path: "/photoGallery", element: "PhotoGallery" },
  { path: "/right-to-information", element: "RightToInfo" },
  { path: "/mission_vision", element: "MissionVision" },
  { path: "/website-notification", element: "WebsiteNotification" },
  { path: "/scheme", element: "Scheme" },
  { path: "/achievers", element: "achiever" },
  { path: "/uddyamaan-unnayan-yojana", element: "UddyamaanUnnayan", props: { schemeType: "uddyamaan" } },
  { path: '/uddyamaan-unnayan-yojana/apply/:programId', element: 'UddyamaanApplyForm', props: { schemeType: "uddyamaan" } },
  { path: '/uddyamaan-unnayan-yojana/my-application', element: 'UddyamaanApplicationView', props: { schemeType: "uddyamaan" } },
  { path: '/uddyamaan-unnayan-yojana/my-assessment', element: 'UddyamaanMyAssessment', props: { schemeType: "uddyamaan" } },
  { path: '/uddyamaan-unnayan-yojana/:id', element: 'UddyamaanDetail', props: { schemeType: "uddyamaan" } },
  { path: "/protsaahan-yojana", element: "UddyamaanUnnayan", props: { schemeType: "protsaahan" } },
  { path: '/protsaahan-yojana/apply/:programId', element: 'UddyamaanApplyForm', props: { schemeType: "protsaahan" } },
  { path: '/protsaahan-yojana/my-application', element: 'UddyamaanApplicationView', props: { schemeType: "protsaahan" } },
  { path: '/protsaahan-yojana/my-assessment', element: 'UddyamaanMyAssessment', props: { schemeType: "protsaahan" } },
  { path: '/protsaahan-yojana/:id', element: 'UddyamaanDetail', props: { schemeType: "protsaahan" } },
  { path: "/cm-trophy", element: "CmTrophyLanding" },
  { path: "/cm-trophy/register", element: "CmTrophyApplyForm" },
  { path: "/cm-trophy/search", element: "CmTrophySearchApplication" },
  { path: "/schemes", element: "Schemes", props: { id: "13" } },
  { path: "/scheme/:id", element: "SchemeDetails" },
  { path: "/venue-list", element: "SlotBooking" },
  { path: "/venue-details", element: "VenueDetails" },
  { path: "/ticket-booking-details/:id", element: "TicketBookingDetails" },
  { path: "/venue-infra", element: "VenueInfraStructure" },
  { path: "/venue-infra-details", element: "VenueInfraStructureDetails" },
  { path: "/venue-slot-booking-status", element: "TicketDetails" },
  { path: "/venue-slot-booking-details", element: "Payment" },
  { path: "/ticket-booking-payment", element: "TicketBookingPayment" },
  { path: "/venue-my-booking", element: "MyBooking" },
  { path: "/venue-booking-details", element: "VenueBookingDetails" },
  { path: "/ticket-booking-list", element: "TicketBooking" },
  { path: "/my-tickets", element: "MyTickets" },
  { path: "/my-tickets-details/:id", element: "MyTicketsDetails" },
  { path: "/comingsoon", element: "ComingSoon" },
  { path: "/govt-order", element: "GovernmentOrder" },
  { path: "/term-condition", element: "TermCondition" },
  { path: "/privacypolicy", element: "PrivacyPolicy" },
  { path: "/privacy-policy", element: "PrivacyPolicyApp" },
  { path: "/cancellation-policy", element: "CancelPolicy" },
  { path: "/*", element: "Error404" },
];

const hideComponentsOnRoutes = [
  "/login_otp",
  "/login_email",
  "/registration",
  "/register_as_support_staff",
  "/register_as_athlete",
  "/register_as_other",
  "/forget-password",
  "/otp-verification",
  "/individual",
  "/create-new-password",
  "/final-submit_individual_registration",
  "/auth_registration",
  "/register_as",
  "/final-status",
  "/otp-verfication",
  "/login/mobile",
];
const hideFooterRoutes = [...hideComponentsOnRoutes, "/infrastructure"];


export default function MainRoutesComp() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  // Visitor tracking used to live only inside FooterNew, so any route with the
  // footer hidden (registration/login/otp flows — most of the actual traffic)
  // never got counted. Track from the route root instead, on every navigation.
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    fetch(`${baseUrl}api/get-visitors`).catch(() => {});
  }, [location.pathname]);
  const currentPath = location.pathname;
  const hideHeaderAndMarque = hideComponentsOnRoutes.includes(
    location.pathname,
  );
  const hideFooter = hideFooterRoutes.includes(currentPath);
  return (
    <>
      <div>
        {!hideHeaderAndMarque && (
          <div>
            <Marque />
            {/* <Header /> */}
            <Navbar />
          </div>
        )}
      </div>
      <ErrorBoundary>
        <Suspense
          fallback={
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <Spinner animation="border" role="status" variant="primary">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            </>
          }
        >
          <Routes>
            {publicRoutes.map((route, index) => {
              const Component = componentMap[route.element];
              return Component ? (
                <Route
                  key={index}
                  path={route.path}
                  element={<Component {...(route.props || {})} />}
                />
              ) : null;
            })}
          </Routes>
        </Suspense>
      </ErrorBoundary>

      {!hideFooter && (
        <>
          {/* <Footer />
          <BottomFooter /> */}
          <FooterNew />
        </>
      )}
    </>
  );
}
